<template>
  <section class="index_section">
    <!-- start: header -->
    <div class="header">
      <div class="header-start">
        <div class="header-title">
          <slot name="title">{{ title }}</slot>
        </div>
      </div>

      <div class="header-end">
        <div class="header-panel">
          <slot name="panel"></slot>
        </div>
      </div>
    </div>
    <!-- end: header -->

    <!-- start: content -->
    <div class="content"><slot></slot></div>
    <!-- end: content -->
  </section>
</template>

<script>
export default {
  name: 'IndexSection',

  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.index_section {
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      border-left: 3px solid $g-color-primary;
      padding-left: 10px;
      font-weight: bold;
      font-size: 14px;
      color: #333;
    }
  }

  .content {
    padding: 20px 30px;
  }
}
</style>
